import { SystemField } from "./system-field";

export class PurchaseReceipt extends SystemField{
     
     receipt_num?:string;
     vendor_id?:string;
     is_create_bill?:number;
     pr_type?:string;
     location_id?:string;
     received_date?:string;
     delivery_by_id?:string;
     status?:string;
     accepted_by_id?:string;
     purchase_bills_id?:string;
     received_by_id?:string;
     total_qty?:number;
     total_cost?:number;
     control_qty?:number;
}
export class PurchaseReceiptTranslation extends SystemField{
     
     lang_code?:string;
     description?:string;
     purchase_receipts_id?:string;
}
